'use client'

import { useCheckout, useModals, usePaymentMethodDiscount } from '@/lib/hooks'
import { useState } from 'react'

import { PaymentCard } from '@/components/molecules'
import { ScrollArea } from '@/components/ui'

interface SelectOtherPaymentTypeProps
  extends React.ComponentPropsWithoutRef<'form'> {
  onClose?: () => void
}

export const SelectOtherPaymentType = ({
  onClose,
}: SelectOtherPaymentTypeProps) => {
  const { setPaymentMethod, setCurrentStep, payment_methods, queryParams } =
    useCheckout()
  const { openModal } = useModals()
  const { applyPaymentMethodDiscount } = usePaymentMethodDiscount()
  const [isApplyingDiscount, setIsApplyingDiscount] = useState(false)
  const handleSubmit = (_data: FormData) => { }

  const handleOnSelect = async (method: any) => {
    setPaymentMethod(method)

    // Check if there are conditional modals to show
    if (method?.future_payment_enabled) {
      // Don't apply discount yet - will be applied after future payment date modal
      openModal('FUTURE_PAYMENT_DATE_AND_REFERENCE')
      return
    }

    if (method?.reference_required && method?.is_gift_card === 0) {
      // Don't apply discount yet - will be applied after custom reference modal
      openModal('CUSTOM_REFERENCE')
      return
    }

    if (method?.is_gift_card === 1) {
      // Don't apply discount yet - will be applied after gift card reference modal
      openModal('GIFT_CARD_REFERENCE')
      return
    }

    if (queryParams?.cartId && method?.id) {
      setIsApplyingDiscount(true)
      try {
        await applyPaymentMethodDiscount({
          cartId: queryParams.cartId,
          paymentMethodId: method.id,
        })
      } catch (error) {
        console.error('Failed to apply/remove discount:', error)
        // Continue even if discount operation fails
      } finally {
        setIsApplyingDiscount(false)
      }
    }

    setCurrentStep('COLLECT_PAYMENT')
    onClose?.()
  }

  return (
    <form
      className="flex min-h-[280px] flex-col gap-4 lg:w-full lg:flex-wrap"
      action={handleSubmit}
    >
      <ScrollArea className="max-h-[264px] lg:w-full">
        <div className="flex w-full flex-col gap-2">
          {payment_methods?.other?.map((method: any, index: number) => (
            <PaymentCard
              key={method.id}
              card={method}
              shortcut={index + 1}
              onClick={() => !isApplyingDiscount && handleOnSelect(method)}
              className={
                isApplyingDiscount ? 'pointer-events-none opacity-50' : undefined
              }
            />
          ))}
        </div>
      </ScrollArea>
    </form>
  )
}
